module.exports = __webpack_public_path__ + "media/icons/star-filled-2-6e7752d9.svg";